import { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { buildHandoffQuery, parsePromoToken } from '@pharmaplan/common';

import { readStoredAttribution } from '../../helpers/attributionStorage';
import { buildPlayStoreUrl } from '../../helpers/storeLinks';

const { REACT_APP_PLAY_STORE_URL, REACT_APP_APPLE_STORE_URL } = process.env;

// THE CAMPAIGN AND PROMO TOKEN TRAVEL THROUGH THE PLAY INSTALL REFERRER ON
// ANDROID. THE APP STORE HAS NO EQUIVALENT, SO THE IOS LINK CARRIES NOTHING
const useStoreUrls = () => {
  const { search } = useLocation();

  return useMemo(() => {
    const handoffQuery = buildHandoffQuery(
      readStoredAttribution(),
      parsePromoToken(search),
    );

    return {
      playStoreUrl: buildPlayStoreUrl(REACT_APP_PLAY_STORE_URL ?? '', handoffQuery),
      appStoreUrl: REACT_APP_APPLE_STORE_URL ?? '',
    };
  }, [search]);
};

export default useStoreUrls;
